import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20product%20flat%20lay%20photography%20with%20colorful%20sneakers%20trendy%20hoodies%20stylish%20bags%20and%20accessories%20arranged%20in%20an%20artistic%20composition%20on%20a%20soft%20warm%20coral%20and%20peach%20gradient%20background%20natural%20daylight%20with%20gentle%20shadows%20modern%20editorial%20aesthetic%20with%20fresh%20spring%20color%20palette%20diverse%20textures%20including%20canvas%20leather%20and%20cotton%20fabric%20clean%20lifestyle%20product%20photography%20with%20energetic%20and%20inviting%20atmosphere&width=1800&height=1200&seq=kakobuy-hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet - katalog produktów"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <p className="text-white/80 text-sm md:text-base font-label tracking-widest uppercase mb-4">
          Polski Katalog 2026
        </p>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4 drop-shadow-lg">
          Kakobuy Spreadsheet
        </h1>

        <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-light italic text-white/95 mb-8 drop-shadow-md">
          Twój przewodnik po najlepszych produktach
        </p>

        <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed drop-shadow-sm">
          Aktualizowany codziennie katalog produktów Kakobuy. Przeglądaj kategorie, porównuj ceny i znajdź to, czego szukasz - wszystko w jednym miejscu.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white text-foreground-900 font-bold text-sm md:text-base hover:bg-accent-400 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap shadow-lg shadow-black/15"
          >
            Kakobuy Spreadsheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-900/25"
          >
            Buy It Now
            <i className="ri-shopping-cart-2-line ml-2"></i>
          </a>
        </div>

        <div ref={dropdownRef} className="relative inline-block">
          <button
            type="button"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center gap-2 px-6 py-3 rounded-full bg-white/25 backdrop-blur-md border border-white/40 text-white font-medium text-sm hover:bg-white/40 transition-all whitespace-nowrap"
          >
            <i className="ri-grid-line"></i>
            <span>Wybierz Kategorię</span>
            {dropdownOpen ? <i className="ri-arrow-up-s-line text-xs transition-transform"></i> : <i className="ri-arrow-down-s-line text-xs transition-transform"></i>}
          </button>

          {dropdownOpen && (
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-72 bg-white rounded-2xl shadow-xl border border-background-200/70 overflow-hidden z-50">
              <div className="max-h-96 overflow-y-auto py-2">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-700 transition-colors whitespace-nowrap"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                      <i className={cat.icon}></i>
                    </span>
                    <span className="font-medium">{cat.namePl}</span>
                    <i className="ri-arrow-right-up-line ml-auto text-xs text-foreground-400"></i>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 animate-bounce">
          <button
            type="button"
            onClick={() => {
              const el = document.getElementById("kategorie");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="w-8 h-8 mx-auto flex items-center justify-center text-white/70 hover:text-white transition-colors"
          >
            <i className="ri-arrow-down-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}